import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useMediaUp } from 'hooks';
import { bgPhone, bgPhone2x, triangleShadow } from 'images/us-energy-solutions';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    padding: theme.spacing(15, 0, 30),
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(20, 0, 50),
    },
  },
  text: {
    maxWidth: 'auto',
    color: theme.palette.primary.light,
    marginLeft: 0,
    marginBottom: theme.spacing(10),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(14),
      marginBottom: 0,
      maxWidth: 410,
      textAlign: 'left',
    },
  },
  image: {
    width: '100%',
    borderRadius: 40,
    background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.09) 00%, rgba(0, 0, 0, 0.40) 100%)',
    boxShadow: '20px 20px 50px rgba(0, 0, 0, 0.35)',
    [theme.breakpoints.up('sm')]: {
      borderRadius: 50,
    },
  },
  imgShadow: {
    borderRadius: 40,
    boxShadow: '80px 80px 150px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    position: 'relative',
    maxWidth: 350,
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      borderRadius: 50,
    },
  },
  triangleShadow: {
    position: 'absolute',
    userSelect: 'none',
  },
  rightTriangle: {
    top: 0,
    right: '-70%',
  },
  bottomTriangle: {
    bottom: '-35%',
    left: 0,
    transform: 'rotate(270deg) scale(-1, 1)',
  },
}));

const GetInTouch: FC = () => {
  const classes = useStyles();
  const isMediumUp = useMediaUp('md');

  return (
    <Container fixed>
      <Grid className={classes.gridContainer} container>
        <Grid lg={9} xs={12} item>
          <Grid alignItems="center" container direction={isMediumUp ? 'row' : 'column-reverse'}>
            <Grid item md={5} xs={12}>
              <Box className={classes.imgShadow}>
                <img className={clsx(classes.triangleShadow, classes.rightTriangle)} src={triangleShadow} alt="shadow" />
                <img src={bgPhone} srcSet={`${bgPhone} 516w, ${bgPhone2x} 1032w`} alt="phone" className={classes.image} />
                <img className={clsx(classes.triangleShadow, classes.bottomTriangle)} src={triangleShadow} alt="shadow" />
              </Box>
            </Grid>
            <Grid item md={7} xs={12}>
              <Typography variant="h1" component="h3" className={classes.text}>
                Get in Touch with Only Two Clicks
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GetInTouch;
